import React from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL } from "../../lib/site";

export const FloatingCall = () => {
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      data-testid="floating-call-button"
      className="lg:hidden fixed bottom-4 left-4 z-50 inline-flex items-center gap-2 bg-[#16a34a] hover:bg-[#15803d] text-white font-heading font-bold uppercase tracking-wide px-5 py-4 rounded-full shadow-hard-sm transition-colors"
      aria-label="Call Journey's Handyman now"
    >
      <Phone className="h-6 w-6" strokeWidth={2.5} /> Call Now
    </a>
  );
};
